'use strict';
(function () {
  if (window.VSKLOCartRenderSync) return;

  function formatMoney(cents) {
    var moneyFormat = window.cartStrings?.money_format || window.themeGlobalVariables?.settings?.money_format;
    if (typeof window.vskloFormatMoney === 'function') return window.vskloFormatMoney(cents);
    if (window.Shopify?.formatMoney && moneyFormat) return window.Shopify.formatMoney(cents, moneyFormat);

    var amount = Number(cents || 0) / 100;
    var currency =
      window.VSKLO_STOREFRONT?.currency ||
      window.Shopify?.currency?.active ||
      window.vskloPresentmentCurrency ||
      '';
    var locale = document.documentElement.lang || undefined;

    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {}
    }

    return amount.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function parseMoneyToCents(value) {
    var raw = String(value || '')
      .replace(/ /g, ' ')
      .replace(/[^0-9,.-]/g, '')
      .trim();
    if (!raw) return 0;

    var normalized = raw;
    var hasComma = normalized.includes(',');
    var hasDot = normalized.includes('.');

    if (hasComma && hasDot) {
      var lastComma = normalized.lastIndexOf(',');
      var lastDot = normalized.lastIndexOf('.');
      if (lastComma > lastDot) normalized = normalized.replace(/\./g, '').replace(',', '.');
      else normalized = normalized.replace(/,/g, '');
    } else if (hasComma) {
      var commaDecimals = normalized.split(',').pop() || '';
      normalized = commaDecimals.length === 2 ? normalized.replace(',', '.') : normalized.replace(/,/g, '');
    } else if (hasDot) {
      var dotDecimals = normalized.split('.').pop() || '';
      normalized = dotDecimals.length === 2 ? normalized : normalized.replace(/\./g, '');
    }

    var amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function readMoneyNodeCents(node) {
    if (!node) return 0;
    var hasCents = node.dataset && Object.prototype.hasOwnProperty.call(node.dataset, 'cents');
    var dataCents = hasCents ? Number(node.dataset.cents) : NaN;
    if (Number.isFinite(dataCents) && dataCents >= 0) return Math.round(dataCents);
    return parseMoneyToCents(node.textContent || '');
  }

  function setMoneyNodeCents(node, cents) {
    if (!node) return;
    var safeCents = Math.max(0, Math.round(Number(cents || 0)));
    node.dataset.cents = String(safeCents);
    var target = node.querySelector('strong') || node;
    target.textContent = formatMoney(safeCents);
  }

  function getQtyHolder(qtyBox) {
    return qtyBox?.closest?.('[data-vsklo-parent-card], [data-vsklo-addon-row], [data-vsklo-orphan]') || null;
  }

  function getLineTotalForQty(qtyBox, holder) {
    if (!qtyBox || !holder) return null;
    if (holder.matches?.('[data-vsklo-parent-card]') && qtyBox.closest('.vsklo-cart-card-main')) {
      return holder.querySelector(':scope > .vsklo-cart-card-main [data-vsklo-line-total]');
    }
    return holder.querySelector('[data-vsklo-line-total]');
  }

  function getUnitCentsForQty(qtyBox, holder, previousQty, lineTotal) {
    var safeQty = Math.max(1, parseInt(previousQty || '1', 10) || 1);

    if (holder?.matches?.('[data-vsklo-parent-card]') && qtyBox?.closest?.('.vsklo-cart-card-main')) {
      var parentUnitNode = holder.querySelector(':scope > .vsklo-cart-card-main .vsklo-cart-unit-price');
      var preciseUnit = Number(parentUnitNode?.dataset?.vskloUnitCents);
      if (Number.isFinite(preciseUnit) && preciseUnit >= 0) return preciseUnit;
      var parentUnit = parseMoneyToCents(parentUnitNode?.textContent || '');
      if (parentUnit > 0) return parentUnit;
    }

    var unitNode = holder?.querySelector?.('.vsklo-cart-unit-price');
    var preciseOther = Number(unitNode?.dataset?.vskloUnitCents);
    if (Number.isFinite(preciseOther) && preciseOther >= 0) return preciseOther;
    var parsedUnit = parseMoneyToCents(unitNode?.textContent || '');
    if (parsedUnit > 0) return parsedUnit;

    var total = readMoneyNodeCents(lineTotal);
    return total > 0 ? Math.round(total / safeQty) : 0;
  }

  function optimisticUpdateQtyTotals(root, qtyBox, previousQty, nextQty) {
    if (!root) return;

    var holder = getQtyHolder(qtyBox);
    if (!holder) return;

    var prev = Math.max(0, parseInt(previousQty || '0', 10) || 0);
    var next = Math.max(0, parseInt(nextQty || '0', 10) || 0);
    if (prev === next) return;

    var lineTotal = getLineTotalForQty(qtyBox, holder);
    var unit = getUnitCentsForQty(qtyBox, holder, Math.max(1, prev || 1), lineTotal);
    if (!unit) return;

    var delta = (next - prev) * unit;
    var currentLineTotal = readMoneyNodeCents(lineTotal);
    var nextLineTotal = holder.matches?.('[data-vsklo-addon-row], [data-vsklo-orphan]')
      ? next * unit
      : Math.max(0, currentLineTotal + delta);

    setMoneyNodeCents(lineTotal, nextLineTotal);

    if (holder.matches?.('[data-vsklo-addon-row]')) {
      var parentCard = holder.closest('[data-vsklo-parent-card]');
      var groupTotal = parentCard?.querySelector(':scope > .vsklo-cart-card-main [data-vsklo-line-total]');
      if (groupTotal) {
        setMoneyNodeCents(groupTotal, Math.max(0, readMoneyNodeCents(groupTotal) + delta));
      }
    }

    var subtotal = root.querySelector('[data-vsklo-subtotal]');
    setMoneyNodeCents(subtotal, Math.max(0, readMoneyNodeCents(subtotal) + delta));
  }

  function updateBadges(root, cart) {
    if (!cart || cart.item_count === undefined) return;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) el.innerHTML = '(' + cart.item_count + ')';
      else el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
    });

    document.querySelector('header-total-price')?.updateTotal?.(cart);
    document.querySelector('free-ship-progress-bar')?.init?.(cart.items_subtotal_price);

    var subtotal = (root && root.querySelector('[data-vsklo-subtotal]')) || document.querySelector('[data-vsklo-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  function publishCartState(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (cart.token) window.__VSKLO_CART_TOKEN__ = cart.token;

    try {
      if (window.VSKLODispatchCartChanged) {
        window.VSKLODispatchCartChanged({ cart: cart, source: 'cart-page' });
      } else {
        document.dispatchEvent(new CustomEvent('vsklo:cart:changed', { detail: { cart: cart } }));
      }
    } catch (error) {}
  }

  function updateCartDomFromState(root, cart, hooks) {
    if (!root || !cart || !Array.isArray(cart.items)) return;

    hooks = hooks || {};
    var isAddon = typeof hooks.isAddon === 'function' ? hooks.isAddon : function () { return false; };
    var itemGroup = typeof hooks.itemGroup === 'function' ? hooks.itemGroup : function () { return ''; };
    var renderAddonEditor = typeof hooks.renderAddonEditor === 'function' ? hooks.renderAddonEditor : function () {};

    publishCartState(cart);
    updateBadges(root, cart);

    var byKey = new Map();
    var addonTotalsByGroup = new Map();

    cart.items.forEach(function (item) {
      byKey.set(item.key, item);
      if (!isAddon(item)) return;
      var groupId = itemGroup(item);
      if (!groupId) return;
      addonTotalsByGroup.set(
        groupId,
        (addonTotalsByGroup.get(groupId) || 0) + Number(item.final_line_price || 0)
      );
    });

    root.querySelectorAll('[data-vsklo-parent-card]').forEach(function (card) {
      var key = card.dataset.cartKey;
      var group = card.dataset.vskloGroupId || '';
      var parentItem = byKey.get(key);

      if (!parentItem) {
        card.remove();
        return;
      }

      var parentInput = card.querySelector(':scope > .vsklo-cart-card-main [data-vsklo-qty-input]');
      if (parentInput) { parentInput.value = parentItem.quantity; parentInput.dataset.value = String(parentItem.quantity); }

      var popupSubmit = card.querySelector('[data-vsklo-cart-addon-popup] .js-vsklo-cart-addons-submit');
      if (popupSubmit) popupSubmit.dataset.parentQuantity = String(parentItem.quantity || 1);

      var groupTotal =
        Number(parentItem.final_line_price || 0) +
        ((card.dataset.vskloGroupOwner !== 'false' && group) ? (addonTotalsByGroup.get(group) || 0) : 0);

      var totalEl = card.querySelector(':scope > .vsklo-cart-card-main [data-vsklo-line-total]');
      if (totalEl) {
        totalEl.dataset.cents = String(groupTotal);
        var strong = totalEl.querySelector('strong') || totalEl;
        strong.textContent = formatMoney(groupTotal);
      }
    });

    root.querySelectorAll('[data-vsklo-addon-row]').forEach(function (row) {
      var key = row.dataset.cartKey;
      var item = byKey.get(key);

      if (!item) {
        row.remove();
        return;
      }

      var input = row.querySelector('[data-vsklo-qty-input]');
      if (input) { input.value = item.quantity; input.dataset.value = String(item.quantity); }

      renderAddonEditor(row, item.quantity);

      var totalEl = row.querySelector('[data-vsklo-line-total]');
      if (totalEl) {
        totalEl.dataset.cents = String(item.final_line_price);
        totalEl.textContent = formatMoney(item.final_line_price);
      }
    });
  }

  window.VSKLOCartRenderSync = Object.freeze({
    formatMoney: formatMoney,
    parseMoneyToCents: parseMoneyToCents,
    optimisticUpdateQtyTotals: optimisticUpdateQtyTotals,
    updateBadges: updateBadges,
    publishCartState: publishCartState,
    updateCartDomFromState: updateCartDomFromState
  });
})();